import get from 'lodash.get';

import { RESET_STATE } from 'services/auth/constants';
import { PayrollExportsState, PayrollExportsActions } from './types';
import { PAYROLL_EXPORTS_SET, PAYROLL_EXPORT_REMOVE } from './constants';

const initialState: PayrollExportsState = [];

export default function payrollExportsReducer(
    state: PayrollExportsState = initialState,
    action: PayrollExportsActions
): PayrollExportsState {
    switch (action.type) {
        case PAYROLL_EXPORTS_SET:
            return get(action, 'payload', []);
        case PAYROLL_EXPORT_REMOVE:
            return state.filter(
                (payrollExport) => payrollExport.id !== action.payload
            );
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
